import axios from "axios";
import OrderFormStep from "../common/OrderFormStep";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import InputTextField from "../components/textField/InputTextField";
import FormTitle from "../components/formTitle/FormTitle";
import "./forms.scss";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";

export default class AccountNumberPage extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      openClear: false,
      showClear: true,
      formState: {
        accountNumber: new FieldState(true),
      },
    };

  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {

    this.setState({ 
      isLoaded: true
    });
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = {
      accountNumber: this.state.formState.accountNumber.value,
    }; 

    if(this.validateData().isValid) {
      localStorage.setItem("accountNumber", data.accountNumber);

      return axios.post(
        Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
        data,
        config
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification("Missing data in required fields", "error");
      return null;
    }
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id]?.isRequired &&
      (formState[id]?.value === "" ||
        formState[id]?.value === 0 ||
        formState[id]?.value === null);
    return errorClass ? true : false;
  }

  handleClickClearOpen = () => {
    this.setState({ openClear: true })
  };

  handleCloseClear = () => {
    this.setState({ openClear: false })
    this.setState({ showClear: true })
  };

  setShowClear = (value) => {
    this.setState({ showClear: value })
  }

  handleClearBack = () => {
    if (this.props.isBilateral) {
      window.location.reload()
    } else {
      this.props.setActiveOuterStep(0);
    }
  };

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Account Number"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            
              <div className="fieldBorder">
                <div className="fieldWrapper">
                <InputTextField
                    label="Account Number"
                    placeholder=""
                    type="text"
                    error={
                      this.handleError("accountNumber") && this.state.isSubmit
                    }
                    required={this.state.formState["accountNumber"].isRequired}
                    margin={true}
                    value={this.state.formState.accountNumber.value}
                    onChange={(e) => {
                      this.onInputChange(e, "accountNumber");
                    }}
                  />

                </div>
              </div>
          </form>
        </div>

        <div className="handelButtons">
          {!this.props.isBilateral ?
            <SecondaryButton
              text="Save As Draft"
              onClick={this.props.handleClickOpen}
            />
            : <></>}
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.props.isBilateral ? this.handleClickClearOpen : this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => {
                this.props.handleBack(this.props.currentIndex - 1);
                if (this.props.setIsBack) this.props.setIsBack(true);
              }}
              disabled={true}
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    if (this.props.isBilateral !== null && this.props.isBilateral) {
                      this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
                    } else {
                      this.props.handleNext(this.props.currentIndex)
                    }
                    this.setState({ isLoading: false });
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        {this.props.isBilateral ?
          <>
            <SaveAsDraft
              open={this.props.open}
              handleClose={this.props.handleClose}
              showSubmit={this.props.showSubmit}
              setShowSubmit={this.props.setShowSubmit}
            />
            <ClearOrder
              openClear={this.state.openClear}
              handleCloseClear={this.handleCloseClear}
              showClear={this.state.showClear}
              setShowClear={this.setShowClear}
              formId={this.props.formTypeId}
              handleClearBack={this.handleClearBack}
            />
          </> :
          <>
            <SaveAsDraft
              open={this.props.open}
              handleClose={this.props.handleClose}
              showSubmit={this.props.showSubmit}
              setShowSubmit={this.props.setShowSubmit}
            />
            <ClearOrder
              openClear={this.props.openClear}
              handleCloseClear={this.props.handleCloseClear}
              showClear={this.props.showClear}
              setShowClear={this.props.setShowClear}
              formId={this.props.formTypeId}
              handleClearBack={this.props.handleClearBack}
            />
          </>}
      </>
    );
  }
}
